var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-split-container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLeftContainer),expression:"showLeftContainer"}],staticClass:"filter-split-container-child left-container",style:({
      width: _vm.showRightContainer
        ? `calc(100% - ${_vm.rightContainerWidth}px)`
        : '100%',
    })},[_vm._t("leftContent")],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRightContainer),expression:"showRightContainer"}],staticClass:"filter-split-container-child right-container",style:({ width: `${_vm.rightContainerWidth}px` })},[_vm._t("rightContent")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }